import React, { Suspense } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { Loader } from '@ld/core';
import Box from '@mui/material/Box';

// @custom
import Logo from '../logo';
import Footer from '../footer';
import useRedirectToApp from './use-redirect-to-app';
import { AuthContainer, ShapesBackground, Main, Card } from './styles';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthContainer>
      <Main $isCentered>
        <Logo height={50} />
        <Card>{children}</Card>
      </Main>
      <Footer />
      <ShapesBackground />
    </AuthContainer>
  );
};

const Fallback = () => (
  <Box display='flex' alignItems='center' justifyContent='center' p={3}>
    <Loader />
  </Box>
);

const AuthLayoutRoute = ({
  component: Component,
  location,
  children,
  ...rest
}: RouteProps & { children?: React.ReactNode }) => {
  useRedirectToApp();
  return (
    <Route
      {...rest}
      render={(props) => (
        <AuthLayout>
          <Suspense fallback={<Fallback />}>
            {Component ? <Component {...props} /> : children}
          </Suspense>
        </AuthLayout>
      )}
    />
  );
};

export default AuthLayoutRoute;
